import { render } from "./dental_procedures.vue?vue&type=template&id=6336eb2f&scoped=true"
import script from "./dental_procedures.vue?vue&type=script&lang=js"
export * from "./dental_procedures.vue?vue&type=script&lang=js"

import "./dental_procedures.vue?vue&type=style&index=0&id=6336eb2f&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6336eb2f"]])

export default __exports__